import { Input, InputProps } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { useDirection } from '~/hooks/i18nHooks';

const LtrInput: FC<InputProps> = ({ prefix, suffix, ...props }) => {
  const dir = useDirection();
  const isRtl = dir === 'rtl';

  const hasAffix = Boolean(prefix || suffix);

  return (
    <StyledInput
      dir="ltr"
      // In RTL: move the prefix to the suffix slot so it appears on the right
      prefix={isRtl ? undefined : prefix}
      suffix={isRtl ? (hasAffix ? <>{prefix}{suffix}</> : undefined) : suffix}
      {...props}
    />
  );
};

const StyledInput = styled(Input)``;

export default LtrInput;
